<div>
  <form [formGroup]="originServiceListForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row" style="margin-top: 20px;">
          @if (addPermission) {
            <a class="__add_client" (click)="openOriginServiceForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Liner Origin Service
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <div class="table-scroll-container">
            <table mat-table matSort [dataSource]="originServiceDatasource" (matSortChange)="sortData($event)">
              <ng-container matColumnDef="lineName">
                <th mat-header-cell *matHeaderCellDef class="header">
                  <div class="sorting_header">
                    <span mat-sort-header>Line</span><br>
                    <input placeholder="Line..." type="search" matInput
                      autocomplete="off" formControlName="lineName" class="mat-input-line">
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.lineName}}</td>
                </ng-container>
                <ng-container matColumnDef="consortiumName">
                  <th mat-header-cell *matHeaderCellDef class="header">
                    <div class="sorting_header">
                      <span mat-sort-header>Consortium</span><br>
                      <input placeholder="Consortium..." type="search" matInput
                        autocomplete="off" formControlName="consortiumName" class="mat-input-custom">
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.consortiumName}}</td>
                  </ng-container>
                  <ng-container matColumnDef="originName">
                    <th mat-header-cell *matHeaderCellDef class="header">
                      <div class="sorting_header">
                        <span mat-sort-header>Origin</span><br>
                        <input placeholder="Origin..." type="search" matInput
                          autocomplete="off" formControlName="originName" class="mat-input-pol">
                        </div>
                      </th>
                      <td mat-cell *matCellDef="let element">{{element.originName}}</td>
                    </ng-container>
                    <ng-container matColumnDef="polName">
                      <th mat-header-cell *matHeaderCellDef class="header">
                        <div class="sorting_header">
                          <span mat-sort-header>POL</span><br>
                          <input placeholder="POL..." type="search" matInput
                            autocomplete="off" formControlName="polName" class="mat-input-pol">
                          </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.polName}}</td>
                      </ng-container>
                      <ng-container matColumnDef="destinationName">
                        <th mat-header-cell *matHeaderCellDef class="header">
                          <div class="sorting_header">
                            <span mat-sort-header>Destination</span><br>
                            <input placeholder="Destination..." type="search" matInput
                              autocomplete="off" formControlName="destinationName" class="mat-input-custom">
                            </div>
                          </th>
                          <td mat-cell *matCellDef="let element">{{element.destinationName}}</td>
                        </ng-container>
                        <ng-container matColumnDef="transhipmentPortNames">
                          <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                              <span mat-sort-header>Via Destination</span><br>
                              <input placeholder="Via Destination..." type="search" matInput
                                autocomplete="off" formControlName="viaDestinationName" class="mat-input-custom">
                              </div>
                            </th>
                            <td mat-cell *matCellDef="let element">{{(element.transhipmentPortNames)!='null'?(element.transhipmentPortNames):'Direct'}}</td>
                          </ng-container>
                          <ng-container matColumnDef="mode">
                            <th mat-header-cell *matHeaderCellDef class="header">
                              <div class="sorting_header">
                                <span mat-sort-header>Mode</span>
                              </div>
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.mode}}</td>
                          </ng-container>
                          <ng-container matColumnDef="deactivated">
                            <th mat-header-cell *matHeaderCellDef class="header">
                              <div class="sorting_header">
                                <span mat-sort-header>Service Status</span>
                              </div>
                            </th>
                            <td mat-cell *matCellDef="let element">{{(element.deactivated)?'Inactive':'Active'}}</td>
                          </ng-container>
                          <ng-container matColumnDef="originStatus">
                            <th mat-header-cell *matHeaderCellDef class="header">
                              <div class="sorting_header">
                                <span mat-sort-header>Origin Status</span>
                                <mat-select formControlName="originStatus" placeholder="Search by Status">
                                  @for (status of statusTypes; track status) {
                                    <mat-option [value]="status.key">
                                      {{status.label}}
                                    </mat-option>
                                  }
                                </mat-select>
                              </div>
                            </th>
                            <td mat-cell *matCellDef="let element">{{element.originStatus}}</td>
                          </ng-container>
                          <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                              <span class="mat-sort-header-content" >Action</span></th>
                              <td class="__action_row" mat-cell *matCellDef="let element">
                                <span class="__action_edit_icon" (click)="openOriginServiceForm(element.linerOriginId)">
                                  <mat-icon>create</mat-icon>
                                </span>
                                @if (element.globallyDeactivated && reactivatePermission) {
                                  <span>
                                    <mat-checkbox style="margin-left: 2px;" (change)="deactivateChanged(element.linerOriginId,$event)" [checked]="checkCheckedCondition(element.linerOriginId)"></mat-checkbox>
                                  </span>
                                }
                              </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: columns;"></tr>
                          </table>
                        </div>
                      }
                    </mat-card-content>
                    <mat-card-actions>
                    </mat-card-actions>
                  </mat-card>
                  @if (viewPermission) {
                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="totalRecords" showFirstLastButtons></mat-paginator>
                  }
                </form>
              </div>



